module.exports = __webpack_public_path__ + "img/upgrade-process.0170eee7.png";